import Grid from '../../../components/grid/Grid';
import { getDataitemsForDevice } from '../../../services/DataitemsAPI';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { formatToBrowserTime } from '../../../utils/timeFormat';
import './DataitemsHistory.css'
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

const DataitemsHistory = ({
    deviceName,
    propertyName
}) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const buildSearchData = () => {
        return {
            device_name: deviceName,
            property_name: propertyName
        };
    };

    const headers = [
        { key: 'id', label: 'ID', visible: false },
        { key: 'PK', label: 'Asset Name', visible: false },
        { key: 'di_name', label: 'Name', width: '30%' },
        { key: 'di_Value', label: 'Value', width: '40%' },
        { key: 'last_Modified', label: 'Last Modified', width: '35%' },
    ];

    const mapApiResponseToGridData = (dataArray) => {
        return (dataArray ?? []).map((item, index) => ({
            id: index + 1,
            PK: item?.PK ?? '',
            di_name: item?.name ?? '',
            di_Value: item?.value ?? '',
            last_Modified: item?.last_modified
                ? formatToBrowserTime(item.last_modified, false, false) // 24-hour with millis
                : '',
        }));
    };

    const loadData = async (searchData) => {
        try {
            setLoading(true);
            const raw = await getDataitemsForDevice(searchData);  // Fetch real data from signed AWS request
            const formatted = Array.isArray(raw) ? raw : [raw]; // Ensure it's an array
            const mapped = mapApiResponseToGridData(formatted);
            setData(mapped);
        } catch (err) {
            console.error('Fetch failed:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!deviceName || !propertyName) {
            setLoading(false);
            toast.error('Missing Device Name or Property Name');
            return;
        }
        loadData(buildSearchData());
    }, [deviceName, propertyName]);

    const handleReset = () => {
        loadData(buildSearchData());
    };


    return (

        <div className='di-page-wrapper'>
            <div className="di-header ">
                <button className="btn btn-primary" onClick={handleReset}>
                    <FontAwesomeIcon icon={faSyncAlt} className="me-1" />
                    Refresh
                </button>
            </div>
            <div className='di-content'>
                <Grid
                    headers={headers}
                    data={data}
                    rowsPerPage={50}
                    canMultiSelect={false}
                    loading={loading}
                    sortable={true}
                />
            </div>
        </div>


    );
};

DataitemsHistory.propTypes = {
    deviceName: PropTypes.string.isRequired,
    propertyName: PropTypes.string.isRequired,
};

export default DataitemsHistory;